import React from "react";
import { Link } from "react-router-dom";
import { Layers, ShoppingBag } from "lucide-react";

export const ShopTheLookSection = ({ outfits }) => {
    if (!outfits || outfits.length === 0) return null;
    return (
        <section className="border-b-2 border-black bg-black text-[#FDFBF7]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16">
                <div className="flex items-end justify-between mb-8 border-b-2 border-[#CCFF00] pb-3 flex-wrap gap-3">
                    <div>
                        <span className="inline-block bg-[#CCFF00] text-black border-2 border-[#CCFF00] px-2 py-1 font-mono text-[10px] uppercase tracking-widest mb-3">
                            <Layers className="w-3 h-3 inline -mt-0.5 mr-1" /> Shop The Look
                        </span>
                        <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight leading-[0.95]">
                            BUNDLES, NOT GUESSES.
                        </h2>
                    </div>
                    <Link
                        to="/outfits"
                        data-testid="outfits-view-all"
                        className="font-mono text-xs uppercase tracking-widest underline underline-offset-4 text-[#CCFF00]"
                    >
                        All looks →
                    </Link>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {outfits.map((o) => (
                        <Link
                            to="/outfits"
                            key={o.id}
                            data-testid={`home-outfit-${o.id}`}
                            className="border-2 border-[#CCFF00] bg-[#FDFBF7] text-black card-lift block"
                        >
                            <div className="grid grid-cols-3 gap-0 border-b-2 border-black">
                                {o.items.slice(0, 3).map((it, idx) => (
                                    <div key={it.product?.id || `${o.id}-${idx}`} className={`aspect-square overflow-hidden ${idx < 2 ? "border-r-2 border-black" : ""} bg-[#FDFBF7]`}>
                                        {it.product?.image_url && (
                                            <img src={it.product.image_url} alt={it.product.name} loading="lazy" className="w-full h-full object-cover" />
                                        )}
                                    </div>
                                ))}
                            </div>
                            <div className="p-4">
                                <p className="font-mono text-[10px] uppercase tracking-widest text-black/60">
                                    {o.vibe} · {o.store_count} stores
                                </p>
                                <p className="font-display text-xl font-black uppercase tracking-tight leading-tight mt-1">
                                    {o.name}
                                </p>
                                <div className="mt-3 flex items-center justify-between">
                                    <span className="font-display font-black text-lg">
                                        ${Number(o.total_price).toFixed(0)}
                                    </span>
                                    <span className="font-mono text-[10px] uppercase tracking-widest inline-flex items-center gap-1">
                                        <ShoppingBag className="w-3 h-3" /> Add the look
                                    </span>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};
